/**
 * Catálogo de tipos de patología para la constancia de entrega de resultado
 * de patología. Agrupado en Gástricas y Colón. La opción "Otro" NO va aquí:
 * es un valor especial en el formulario que habilita texto libre.
 */
export type PathologyGroup = 'Gastrica' | 'Colon';

export interface PathologyTypeCatalogEntry {
  readonly id: string;
  readonly nombre: string;
  readonly grupo: PathologyGroup;
}

export const PATHOLOGY_GROUP_LABELS: Record<PathologyGroup, string> = {
  Gastrica: 'Gástricas',
  Colon: 'Colón',
};

export const PATHOLOGY_TYPES_CATALOG: readonly PathologyTypeCatalogEntry[] = [
  // Gástricas
  { id: 'antro', nombre: 'Antro', grupo: 'Gastrica' },
  { id: 'antro-cuerpo', nombre: 'Antro cuerpo', grupo: 'Gastrica' },
  { id: 'antro-incisura-cuerpo', nombre: 'Antro incisura cuerpo', grupo: 'Gastrica' },
  { id: 'duodeno', nombre: 'Duodeno', grupo: 'Gastrica' },
  { id: 'ulcera-gastrica', nombre: 'Úlcera gástrica', grupo: 'Gastrica' },
  { id: 'borde-ulcera-gastrica', nombre: 'Borde úlcera gástrica', grupo: 'Gastrica' },
  { id: 'bulbo-duodenal', nombre: 'Bulbo duodenal', grupo: 'Gastrica' },
  { id: 'lesion-gastrica', nombre: 'Lesión gástrica', grupo: 'Gastrica' },
  { id: 'esofago', nombre: 'Esófago', grupo: 'Gastrica' },
  { id: 'esofago-distal', nombre: 'Esófago distal', grupo: 'Gastrica' },
  // Colón
  { id: 'colon-sigmoide', nombre: 'Colon sigmoide', grupo: 'Colon' },
  { id: 'colon-ascendente', nombre: 'Colon ascendente', grupo: 'Colon' },
  { id: 'colon-transverso', nombre: 'Colon transverso', grupo: 'Colon' },
  { id: 'colon-descendente', nombre: 'Colon descendente', grupo: 'Colon' },
  { id: 'ciego', nombre: 'Ciego', grupo: 'Colon' },
  { id: 'ileon', nombre: 'Íleon', grupo: 'Colon' },
  { id: 'polipo-colon', nombre: 'Pólipo colon', grupo: 'Colon' },
  { id: 'recto', nombre: 'Recto', grupo: 'Colon' },
  { id: 'rectosigmoide', nombre: 'Rectosigmoide', grupo: 'Colon' },
  { id: 'lesion-colon', nombre: 'Lesión de colon', grupo: 'Colon' },
  { id: 'ca-colon', nombre: 'CA de colon', grupo: 'Colon' },
  { id: 'ca-recto', nombre: 'CA de recto', grupo: 'Colon' },
];
